<div class="form-goods">
    <h2 class="subtitle" [innerHtml]="copyService.copies.form_goods_subtitle"></h2>
    <form [formGroup]="formGroup">
        <div class="form col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4" *ngIf="this.abreCuentasService.viewOptionMultiProduct">
            <vcl-form-field class="field" label="{{ copyService.copies.form_goods_active_label }}"
                msgErr="{{ copyService.copies.form_goods_error_aproximate_wines }}">
                <input vclInput id="input-active" voxelMask="currency" [config]="config" 
                    placeholder="{{ copyService.copies.form_goods_active_placeholder }}" 
                    [value]="financialInfo.goods" (change)="reactiveInputChangeActive()"
                    (focus)="reactiveOnFocus()" formControlName="input-value-active" max="999999999999">
                <div class="note" id="generalSpan">{{ copyService.copies.form_goods_active_note }}</div>
            </vcl-form-field>
            <vcl-form-field class="field"
                label="{{ copyService.copies.form_goods_passive_label }}"
                msgErr="{{ copyService.copies.form_goods_error_aproximate_wines }}">
                <input 
                    vclInput id="input-passive" voxelMask="currency" [config]="config"
                    placeholder="{{ copyService.copies.form_goods_passive_placeholder }}" 
                    [value]="financialInfo.debt" (change)="reactiveInputChangePassive()"
                    formControlName="input-value-passive" max="999999999999">
                <div class="note">{{ copyService.copies.form_goods_passive_note }}</div>
            </vcl-form-field>
        </div>
        <div class="form col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4" *ngIf="!this.abreCuentasService.viewOptionMultiProduct">
            <vcl-form-field class="field" label="{{ copyService.copies.form_goods_active_label }}"
                msgErr="{{ copyService.copies.form_goods_error }}">
                <input vclInput id="input-active" voxelMask="currency" [config]="config" 
                    placeholder="{{ copyService.copies.form_goods_active_placeholder }}" 
                    [value]="financialInfo.goods" (change)="reactiveInputChangeActive()"
                    (focus)="reactiveOnFocus()" formControlName="input-value-active" max="999999999999">
                <div class="note" id="generalSpan">{{ copyService.copies.form_goods_active_note }}</div>
            </vcl-form-field>
            <vcl-form-field class="field"
                label="{{ copyService.copies.form_goods_passive_label }}"
                msgErr="{{ copyService.copies.form_goods_error }}">
                <input 
                    vclInput id="input-passive" voxelMask="currency" [config]="config"
                    placeholder="{{ copyService.copies.form_goods_passive_placeholder }}" 
                    [value]="financialInfo.debt" (change)="reactiveInputChangePassive()"
                    formControlName="input-value-passive" max="999999999999">
                <div class="note">{{ copyService.copies.form_goods_passive_note }}</div>
            </vcl-form-field>
        </div>
        
    </form>
</div>
<app-controls id="formGoodsBtns" [hasPrevious]="true" [nextLabel]="copyService.copies.form_goods_button"
    [nextDisabled]="!formGroup.valid " (next)="next()"></app-controls>